import { useEffect } from 'react';

const SEOHead = ({ 
  title = "X67 Digital, Anunțuri Gratuite în România | Auto, Imobiliare, Electronice",
  description = "Marketplace românesc gratuit cu licitații live, escrow integrat, AI vision și verificare KYC. Mașini, apartamente, electronice, joburi în 368 de localități.",
  keywords = "anunturi gratuite, anunturi romania, masini second hand, auto romania, apartamente de vanzare, case de vanzare, imobiliare, electronice, telefoane, laptopuri, locuri de munca, joburi romania",
  image = "https://x67digital.com/og-image.png",
  url = "https://x67digital.com",
  type = "website",
  noindex = false
}) => {
  useEffect(() => {
    document.title = title;
    
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };
    
    // Standard meta
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    
    // Robots
    if (noindex) {
      updateMeta('robots', 'noindex, nofollow');
    } else {
      updateMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    }
    
    // Open Graph
    updateMeta('og:title', title, true);
    updateMeta('og:description', description, true);
    updateMeta('og:image', image, true);
    updateMeta('og:url', url, true);
    updateMeta('og:type', type, true);
    updateMeta('og:site_name', 'X67 Digital Media', true);
    updateMeta('og:locale', 'ro_RO', true);
    
    // Twitter
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
    updateMeta('twitter:image', image);
    
    // Additional SEO meta
    updateMeta('author', 'X67 Digital Media Groupe');
    updateMeta('geo.region', 'RO');
    updateMeta('geo.placename', 'Romania');
    updateMeta('content-language', 'ro');
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', url);
      document.head.appendChild(canonical);
    }
    
    // Alternate hreflang
    let hreflang = document.querySelector('link[hreflang="ro"]');
    if (!hreflang) {
      hreflang = document.createElement('link');
      hreflang.setAttribute('rel', 'alternate');
      hreflang.setAttribute('hreflang', 'ro');
      hreflang.setAttribute('href', url);
      document.head.appendChild(hreflang);
    } else {
      hreflang.setAttribute('href', url);
    }
  }, [title, description, keywords, image, url, type, noindex]);
  
  return null;
};

export default SEOHead;
